// Analytics for the payment-method popup. `source` records which entry point
// opened it; each PRESENTATION emits one terminal event — `userNoticeActionTapped`
// OR `userNoticeDismissed` — so a session that sees both surfaces emits two.
import { trackEvent } from '@/core/analytics'

const SCREEN_NAME = 'userNotice'
const SCREEN_TYPE = 'modal'

export type UserNoticeSource = 'launch' | 'profile'
// Stringified at the analytics boundary; the SOFT nudge and the HARD dead-end
// convert differently, so every event carries which one it was.
export type UserNoticeVariant = 'soft' | 'hard'

function base(source: UserNoticeSource, noticeType: UserNoticeVariant) {
  return {
    screenName: SCREEN_NAME,
    screenType: SCREEN_TYPE,
    source,
    noticeType,
  }
}

export function trackUserNoticeScreenView(
  source: UserNoticeSource,
  noticeType: UserNoticeVariant,
) {
  trackEvent('screenView', base(source, noticeType))
}

// The × is the only way out here, so `closeMethod` is constant.
export function trackUserNoticeDismissed(
  source: UserNoticeSource,
  noticeType: UserNoticeVariant,
) {
  trackEvent('userNoticeDismissed', {
    ...base(source, noticeType),
    closeMethod: 'button',
  })
}

export function trackUserNoticeActionTapped(
  source: UserNoticeSource,
  noticeType: UserNoticeVariant,
) {
  trackEvent('userNoticeActionTapped', base(source, noticeType))
}
